import React,{useState,useEffect,useRef} from "react";
import { Link } from "react-router-dom";
import { getAWSUrl } from "../api/core";



const LandingHeader = (props) =>{
  const [show,SetShow] = useState(false);
  
  const mounted = useRef(false);
  const [showMobile,SetShowMobile] = useState(false);
  const [scrolled,setScrolled]=React.useState(false);
   /* eslint-disable no-unused-vars */  
   const [menuSchema, setMenu] = useState([]);

    /* eslint-disable no-unused-vars */  
  const [branding,setBranding]=useState('');
  const node = useRef();

/* 
  const moreMenu = (event) =>{
    event.preventDefault();
    SetShow(!show);
  } */
  const mobileNav = (event) =>{
    event.preventDefault();
    SetShowMobile(!show);
  }
  const handleScroll=() => {
    const offset=window.scrollY;
    if(offset > 200 ){
      setScrolled(true);
    }
    else{
      setScrolled(false);
    }
  }

  const handleClick = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click 
     SetShow(false);
     SetShowMobile(false);
  };
  useEffect(() => {

    mounted.current = true;
    window.addEventListener('scroll',handleScroll);

     // add when mounted
  document.addEventListener("mousedown", handleClick);
  // return function to be called when unmounted
  if(mounted.current)
  {
    setBranding(props.branding);
    setMenu(props.data);

  }

    
    
  return () => {
    document.removeEventListener("mousedown", handleClick);
    mounted.current = false;
  };

 
  },[props.branding,props.data])
 
return(
    <header id="main-header" className={scrolled?"scrolled":""} ref={node}>
      <div className="main-header">
        <div className="container-fluid pad-left">
          <div className="row">
            <div className="col-sm-12">
              <nav className="navbar navbar-expand-lg navbar-light p-0">
                <Link to="#!" className="navbar-toggler c-toggler" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <div className="navbar-toggler-icon" data-toggle="collapse" onClick={mobileNav}>
                    <span className="navbar-menu-icon navbar-menu-icon--top" />
                    <span className="navbar-menu-icon navbar-menu-icon--middle" />
                    <span className="navbar-menu-icon navbar-menu-icon--bottom" />
                  </div>
                </Link>
                <Link className="navbar-brand center-align" to={"/"+props.match.params.AppId+"/home"}> <img className="img-fluid logo" src={getAWSUrl()+branding} alt="SMOTT" /> </Link>
                <div className={`collapse navbar-collapse ${showMobile?"show":""}`} id="navbarSupportedContent">
                  <div className="menu-main-menu-container">
                   
                    <ul id="top-menu" className="navbar-nav ml-auto top-right">
                    <li className="menu-item">
                     <Link to={"/"+props.match.params.AppId+"/aboutus"}>About</Link>
                    </li>
                    <li className="menu-item">
                     <Link to={"/"+props.match.params.AppId+"/contactus"}>Contact</Link>
                    </li>
                    <li className="menu-item">
                     <Link to={"/"+props.match.params.AppId+"/premium"}>Premium</Link>
                    </li>
                     
                    <li className="menu-item">
                     <Link to={"/"+props.match.params.AppId+"/login"}>Login</Link>
                    </li>
 {/*           <li className="menu-item">
                                   <Link to="#">Pages</Link>
                                    <ul className="sub-menu">
                                       <li className="menu-item"><a href="about-us.html">About Us</Link></li>
                                       <li className="menu-item "><a href="contact.html">Contact</Link></li>
                                       <li className="menu-item"><a href="faq.html">FAQ</Link></li>
                                       <li className="menu-item"><a href="privacy-policy.html">Privacy-Policy</Link></li>
                                       <li className="menu-item"><a href="p.html">Pricing</Link>
                                    </li>
                                    </ul>
                                 </li> */}
                    </ul>
                  </div>
                
                
                </div>
             
              </nav>
              <div className="nav-overlay" />
            </div>
          </div>
        </div>
      </div>
    </header>);

}

export default LandingHeader;